import { put, select } from "redux-saga/effects";
import { EarnResponse, TravelProductEnum } from "redmond";
import { getHSPEarnOfferDescription } from "halifax";
import { actions } from "../actions";
import { productToEarn } from "../../../api/v1/rewards/productToEarn";
import { IStoreState } from "../../../reducers/types";
import {
  getTotalCreditCardPaymentRequiredInFiatPrice,
  getCardPaymentAccount,
  getOfferToApply,
} from "../reducer";
import { getRewardsAccountForBanner } from "../../rewards/reducer/selectors";
import Logger from "../../../utils/logger";

export function* fetchProductToEarnSaga() {
  try {
    const state: IStoreState = yield select();
    const paymentTotal = getTotalCreditCardPaymentRequiredInFiatPrice(state);
    const cardPaymentAccount = getCardPaymentAccount(state);
    const bannerAccount = getRewardsAccountForBanner(state);

    const accountReferenceId =
      cardPaymentAccount?.accountReferenceId ||
      bannerAccount?.accountReferenceId;

    if (!accountReferenceId || !paymentTotal?.value) {
      return;
    }

    const offerToApply = getOfferToApply(state);

    const hspEarnOfferDescription = getHSPEarnOfferDescription(offerToApply);

    const result: EarnResponse = yield productToEarn({
      account: accountReferenceId,
      travelProduct: TravelProductEnum.Cars,
      amountUsd: paymentTotal.value,
      earnOfferDescription: hspEarnOfferDescription,
    });

    yield put(actions.setEarnValue(result));
  } catch (e) {
    Logger.debug(e);
  }
}
